import Cookies from "js-cookie";
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import { useDispatch, useSelector } from "react-redux";
import "react-resizable/css/styles.css";
import "../ApplicantsDashboard/applicantsdashboard.css";
import "./ApplicantsNewDashboard.css";

import {
  customFieldsAsync,
  updateDashboardConfigAsync,
} from "../../../_redux/_services/UserManagerSlice";
import { decrypt } from "../../../_utilities/_encryptDecryptHelper";
import {
  getCandidateInternalStatus,
  getCandidateStatusCustomValues,
} from "../../../_utilities/internalexternalhelper";
import useUnsavedChangesWarning from "../../../hooks/useUnsavedChangesWarning";

import * as _appSer from "../../../_redux/_services/ApplicantsSlice";
import AddEditModal from "./AddEditModal/AddEditModal";
import BarChartWidgetCard from "./BarChartWidget/BarChartWidget";
import ImportModal from "./CardTitle/ImportModal";
import DateTimeContainer from "./DateTime/Datetime";
import InformationWidgetCard from "./InfoWidget/InformationWidget";
import LinearProgressGraphWidgetCard from "./LinearProgressGraphWidget/LinearProgressGraphWidget";
import LinearProgressWidgetCard from "./LinearProgressWidget/LinearProgressWidget";
import PieChartWidgetCard from "./PieChartWidget/PieChartWidget";
import TableWidgetCard from "./TableWidget/TableWidget";
import {
  additionalWidgetTypes,
  commonWidgetContent,
  infoWidgetList,
  initialLayoutConfig,
  widgetTypes,
} from "./widget";

import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import { setConfirmed } from "../../../_redux/UnsavedSlice";
import { GetTimeZone } from "../../../_utilities/GetTimeZone";
import {
  getInterviewInfo,
  getResumeInfo,
  getSelectedInfo,
  getSubmissionInfo,
} from "./utils";

import {
  GetUserId,
  GetUserInfo,
  getAttributes,
} from "../../../_utilities/getUserInfo";
const initalState = {
  data: null,
  updatedata: null,
  message: "",
  id: null,
  code: null,
  oldApplicantName: null,
  isDuplicats: null,
};

const randomColors = [
  "#d7c48c",
  "#908c8c",
  "#e57373",
  "#6b8ebf",
  "#87b97a",
  "#9c9494",
  "#8ba3bc",
  "#9fbb7d",
  "#dcc882",
  "#e76f51",
  "#2a9d8f",
  "#c88d68",
  "#6e6a52",
  "#5c6c74",
  "#6c5444",
  "#c9c9c9",
];

const ApplicantsNewDashboard = () => {
  const startDate = dayjs().subtract(7, "day").toDate();
  const endDate = new Date();
  const formatStartDate = dayjs(startDate).format("YYYY-MM-DD");
  const formatEndDate = dayjs(endDate).format("YYYY-MM-DD");

  const [layoutConfig, setLayoutConfig] = useState([]);
  const [previouslayoutConfig, setPreviouslayoutConfig] = useState([]);
  const [gridWidth, setGridWidth] = useState(1200);
  const [editMode, setEditMode] = useState(false);
  const [listOfWidgets, setListOfWidgets] = useState(widgetTypes);

  const [pieChartSwitchList, setPieChartSwitch] = useState([]);
  const [barChartSwitchList, setBarChartSwitch] = useState([]);
  const [tableSwitchList, setTableSwitch] = useState([]);
  const [selectedCardTitle, setSelectedCardTitle] = useState("");

  const [infoWidgetsData, setInfoWidgetscData] = useState({});
  const [pieChartData, setPieChartData] = useState({});
  const [barChartData, setBarChartData] = useState({});
  const [tableData, setTableData] = useState({});
  const [graphOfStatusData, setGraphOfStatusData] = useState({});
  const [graphByClientData, setGraphByClientData] = useState({});
  const [jobStatusByClientData, setJobStatusByClientData] = useState({});
  const [resumeCountByStatus, setResumeCountByStatus] = useState({});
  const [totalUploadedResumes, setTotalUploadedResumes] = useState({});
  const [deliveryOutcomeData, setDeliveryOutcomeData] = useState({});
  const [totalRecruiterData, setTotalRecruiterData] = useState({});
  const [totalRecruiterCount, setTotalRecruiterCount] = useState({});
  const [addEditCard, setAddEditCard] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [candidateStatusValues, setCandidateStatusValues] = useState([]);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const [selectedDate, setSelectedDate] = useState({
    startDate: formatStartDate,
    endDate: formatEndDate,
  });
  const [candidateListByStatusData, setCandidateListByStatusData] = useState(
    {},
  );

  const widgetsResponse = useSelector((state) => state.GetResumeCount.data);
  const pieChartResponse = useSelector((state) => state.GetPieChartData.data);
  const barChartResponse = useSelector((state) => state.GetBarChartData.data);
  const customFieldsData = useSelector((state) => state.CustomFields.data);
  const graphOfStatus = useSelector((state) => state.GetGraphOfStatus.data);
  const graphbyclients = useSelector((state) => state.GetGraphByClient.data);
  const jobStatusByClient = useSelector(
    (state) => state.JobStatusByClient.data,
  );
  const deliveryOutcome = useSelector(
    (state) => state.DeliveryOutcomeByClients.data,
  );
  const totalRecruiterCountResponse = useSelector(
    (state) => state.TotalRecruiter.recruiterWithCount,
  );
  const RecruiterStatusResponse = useSelector(
    (state) => state.TotalRecruiter.recruiterWithStatus,
  );
  const candidateListByStatusResponse = useSelector(
    (state) => state.CandidateListByStatus.data,
  );

  const resumeContributedByStatus = useSelector(
    (state) => state.GetResumeCountByStatus.data,
  );
  const totalResumesData = useSelector(
    (state) => state.TotalUploadedResumes.data,
  );

  const requirementAssignedResponse = useSelector(
    (state) => state.GetRequirementAssigned.data,
  );
  const isConfirmedPopup = useSelector(
    (state) => state.Unsaved.isConfirmedType,
  );

  const [countryId, setCountryId] = useState("");

  const containerRef = useRef(null);
  const newCardRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useUnsavedChangesWarning(
    unsavedChanges,
    "You have unsaved changes. Are you sure you want to leave?",
  );

  const reloadPage = (config = []) => {
    config.forEach((card) => {
      getNewGraphDetails(card);
    });
    setPreviouslayoutConfig([]);
  };

  useEffect(() => {
    async function init() {
      const userInfo = await GetUserInfo();
      let userCountries = JSON.parse(userInfo[0].selectedcountries);
      const teamRoles = userInfo[0].teamRoles;
      setShowToggle(teamRoles !== "Recruiter" ? true : false);
      setCountryId(userCountries[0].id);
    }
    init();
  }, []);

  const selectedCountry = JSON.parse(decrypt("selectCountry"));
  const allCountries = JSON.parse(decrypt("allCountryId"));
  const prevCountry = Cookies.get("selectCountryId")
    ? Cookies.get("selectCountryId")
    : countryId;

  //getGraphOfStatusAsync
  const getGraphOfStatusData = (widget) => {
    const requestBody = {
      widgetId: widget.i,
      status: widget.status.join(","),
      startDate: selectedDate?.startDate,
      endDate: selectedDate?.endDate,
      countryId:
        allCountries === "all"
          ? allCountries
          : selectedCountry?.id
            ? selectedCountry?.id
            : prevCountry,
    };
    dispatch(_appSer.getGraphOfStatusAsync(requestBody));
  };

  //getGraphByClientAsync
  const getGraphbyClientData = (widget) => {
    const requestBody = {
      client: widget.client.id,
      widgetId: widget.i,
      status: widget.status.join(","),
      startDate: selectedDate?.startDate,
      endDate: selectedDate?.endDate,
      countryId:
        allCountries === "all"
          ? allCountries
          : selectedCountry?.id
            ? selectedCountry?.id
            : prevCountry,
    };
    dispatch(_appSer.getGraphByClientAsync(requestBody));
  };

  //getJobStatusByClientAsync
  const getJobStatusByClientData = (widget) => {
    const requestBody = {
      client: widget.client.id,
      widgetId: widget.i,
      status: widget.status.join(","),
      startDate: selectedDate?.startDate,
      endDate: selectedDate?.endDate,
      countryId:
        allCountries === "all"
          ? allCountries
          : selectedCountry?.id
            ? selectedCountry?.id
            : prevCountry,
    };
    dispatch(_appSer.getJobStatusByClientAsync(requestBody));
  };

  //getGraphByClientAsync
  const getResumeContributed = async (widget) => {
    const getAttribute = await getAttributes();
    const requestBody = {
      widgetId: widget.i,
      status: widget.status.join(","),
      startDate: selectedDate?.startDate,
      endDate: selectedDate?.endDate,
      userId: getAttribute[0].userId,
      countryId:
        allCountries === "all"
          ? allCountries
          : selectedCountry?.id
            ? selectedCountry?.id
            : prevCountry,
    };
    dispatch(_appSer.getResumeCountByStatusAsync(requestBody));
  };

  //getTotalGraphByClientAsync
  const getTotalUploadedResumesContributed = async (widget) => {
    const getAttribute = await getAttributes();
    const requestBody = {
      widgetId: widget.i,
      startDate: selectedDate?.startDate,
      endDate: selectedDate?.endDate,
      userId: getAttribute[0].userId,
      countryId:
        allCountries === "all"
          ? allCountries
          : selectedCountry?.id
            ? selectedCountry?.id
            : prevCountry,
    };
    dispatch(_appSer.getTotalUploadedResumesAsync(requestBody));
  };

  //GraphbyRecruiter and RecruiterContributionByStatus
  const getTotalRecruiterContribution = async (widget, resumesUploaded) => {
    const getAttribute = await getAttributes();
    const requestBody = {
      widgetId: widget.i,
      startDate: selectedDate?.startDate,
      endDate: selectedDate?.endDate,
      customerid: await GetUserId(),
      countryId:
        allCountries === "all"
          ? allCountries
          : selectedCountry?.id
            ? selectedCountry?.id
            : prevCountry,
      userId: getAttribute[0].userId,
      resumesUploaded: resumesUploaded,
      candidateStatus: resumesUploaded === 1 ? [] : widget.status,
      recruiters: widget.recruiters,
    };
    const type =
      resumesUploaded === 1
        ? "GraphbyRecruiter"
        : "RecruiterContributionByStatus";
    dispatch(_appSer.getTotalRecruiterAsync(requestBody, type));
  };

  //GraphbyRecruiter and RecruiterContributionByStatus
  const getDeliveryOutcomeByClients = async (widget) => {
    const getAttribute = await getAttributes();
    const requestBody = {
      widgetId: widget.i,
      startDate: selectedDate?.startDate,
      endDate: selectedDate?.endDate,
      customerid: await GetUserId(),
      countryId:
        allCountries === "all"
          ? allCountries
          : selectedCountry?.id
            ? selectedCountry?.id
            : prevCountry,
      userId: getAttribute[0].userId,
      status: widget.status,
      clientId: widget.client,
    };
    dispatch(_appSer.getDeliveryOutcomeByClientsAsync(requestBody));
  };

  //GraphbyRecruiter and RecruiterContributionByStatus
  const getCandidateDetailsByStatus = async (widget) => {
    const getAttribute = await getAttributes();
    const requestBody = {
      widgetId: widget.i,
      startDate: selectedDate?.startDate,
      endDate: selectedDate?.endDate,
      customerid: await GetUserId(),
      countryId:
        allCountries === "all"
          ? allCountries
          : selectedCountry?.id
            ? selectedCountry?.id
            : prevCountry,
      userId: getAttribute[0].userId,
      status: widget.status,
      clientId: widget.client,
    };
    dispatch(_appSer.getCandidateListByStatusAsync(requestBody));
  };

  const movePositionToNewCard = (id) => {
    if (id) {
      const element = document.querySelector(`[data-grid-id='${id}']`);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth", // Smooth scroll effect
          block: "end", // Scroll to the center vertically
          inline: "nearest", // Keep it in the nearest horizontal alignment
        });
        newCardRef.current = element;
      }
    }
  };

  const getNewGraphDetails = (card) => {
    switch (card.type) {
      case "GraphofStatus":
        getGraphOfStatusData(card);
        return null;
      case "GraphbyClient":
        getGraphbyClientData(card);
        return null;
      case "JobStatusByClient":
        getJobStatusByClientData(card);
        return null;
      case "ResumeCount":
        getResumeContributed(card);
        return null;
      case "TotalUploadedResumes":
        getTotalUploadedResumesContributed(card);
        return null;
      case "GraphbyRecruiter":
        getTotalRecruiterContribution(card, 1);
        return null;
      case "RecruiterContributionByStatus":
        getTotalRecruiterContribution(card, 0);
        return null;
      case "DeliveryOutcomeByClients":
        getDeliveryOutcomeByClients(card);
        return null;
      case "candidateDetailsByStatus":
        getCandidateDetailsByStatus(card);
        return null;
      default:
        return standedCardMappingData(card);
    }
  };

  const standedCardMappingData = (card) => {
    if (infoWidgetList.includes(card.type)) {
      return { ...card, data: infoWidgetsData[card.type] };
    } else if (card.type === "pieChart") {
      if (pieChartSwitchList.includes(card.i)) {
        return {
          ...card,
          data: pieChartData.company,
          h: pieChartData?.company?.length > 0 ? 7 : 3,
        };
      }
      return {
        ...card,
        data: pieChartData.user,
        h: pieChartData?.user?.length > 0 ? 7 : 3,
      };
    } else if (card.type === "barChart") {
      if (barChartSwitchList.includes(card.i)) {
        return {
          ...card,
          data: barChartData.company,
          h:
            barChartData?.company && barChartData?.company[0]?.length > 0
              ? 7
              : 3,
        };
      }
      return {
        ...card,
        data: barChartData.user,
        h: barChartData?.user && barChartData?.user[0]?.length > 0 ? 7 : 3,
      };
    } else if (card.type === "requirementsWidget") {
      if (tableSwitchList.includes(card.i)) {
        return {
          ...card,
          data: tableData.company,
          h: tableData?.company?.length > 0 ? 12 : 4,
        };
      }
      return {
        ...card,
        data: tableData.user,
        h: tableData?.user?.length > 0 ? 12 : 4,
      };
    } else if (card.type === "GraphofStatus") {
      return {
        ...card,
        data: graphOfStatusData[card.i],
        h:
          graphOfStatusData[card.i] && graphOfStatusData[card.i][0]?.length > 0
            ? 7
            : 3,
      };
    } else if (card.type === "GraphbyClient") {
      return {
        ...card,
        data: graphByClientData[card.i],
        h: graphByClientData[card.i]?.length > 0 ? 7 : 3,
      };
    } else if (card.type === "JobStatusByClient") {
      return {
        ...card,
        data: jobStatusByClientData[card.i],
        h: jobStatusByClientData[card.i]?.length > 0 ? 7 : 3,
      };
    } else if (card.type === "ResumeCount") {
      return {
        ...card,
        data: resumeCountByStatus[card.i],
      };
    } else if (card.type === "TotalUploadedResumes") {
      return {
        ...card,
        data: totalUploadedResumes[card.i],
      };
    } else if (card.type === "DeliveryOutcomeByClients") {
      return {
        ...card,
        data: deliveryOutcomeData[card.i]?.data,
        series: deliveryOutcomeData[card.i]?.series,
        h: Math.max(5, (deliveryOutcomeData[card.i]?.data?.length || 2) * 2),
      };
    } else if (card.type === "RecruiterContributionByStatus") {
      return {
        ...card,
        data: totalRecruiterData[card.i]?.data,
        series: totalRecruiterData[card.i]?.series,
        h: Math.max(5, (totalRecruiterData[card.i]?.data?.length || 2) * 2),
      };
    } else if (card.type === "GraphbyRecruiter") {
      return {
        ...card,
        data: totalRecruiterCount[card.i]?.data,
        series: totalRecruiterCount[card.i]?.series,
        h: Math.max(5, (totalRecruiterCount[card.i]?.data?.length || 2) * 2),
      };
    } else if (card.type === "candidateDetailsByStatus") {
      return {
        ...card,
        data: candidateListByStatusData[card.i]?.data,
        h: candidateListByStatusData[card.i]?.data?.length > 0 ? 12 : 4,
      };
    } else {
      return card;
    }
  };

  const pieChartSwitchChange = (value, card) => {
    const list = [...pieChartSwitchList];
    const updatedList = updateList(list, value, card.i);
    setPieChartSwitch(updatedList);
  };

  const barChartSwitchChange = (value, card) => {
    const list = [...barChartSwitchList];
    const updatedList = updateList(list, value, card.i);
    setBarChartSwitch(updatedList);
  };

  const tableSwitchChange = (value, card) => {
    const list = [...tableSwitchList];
    const updatedList = updateList(list, value, card.i);
    setTableSwitch(updatedList);
  };

  const updateList = (list = [], value, i) => {
    if (value) {
      list.push(i);
    } else {
      const index = list.findIndex((value) => i === value);
      list.splice(index, 1);
    }
    return list;
  };

  /**
   * Card actions
   */
  const handleSaveCardTitle = (id, title) => {
    setSelectedCardTitle("");
    setLayoutConfig((prevLayout) =>
      prevLayout.map((card) => {
        if (card.i === id) {
          return { ...card, title: title };
        }
        return card;
      }),
    );
  };
  const handleAddCard = (updatedCard) => {
    if (updatedCard.i) {
      setLayoutConfig((prevLayout) =>
        prevLayout.map((card) => {
          if (card.i === updatedCard.i) {
            delete updatedCard.description;
            delete updatedCard.sampleImg;
            const finalCard = { ...card, ...updatedCard, h: card.h };
            return finalCard;
          }
          return card;
        }),
      );
      getNewGraphDetails(updatedCard);
    } else {
      // Find the highest key from the layout to avoid duplicates
      const maxKey = layoutConfig.reduce(
        (max, card) => Math.max(max, parseInt(card.i, 10)),
        0,
      );

      // Find the first available position in the grid (empty slot)
      let newCardX = 0;
      let newCardY = 0;
      let foundSlot = false;

      // Traverse the grid to find the first empty slot
      while (!foundSlot) {
        foundSlot = true;
        // Check if the new slot (newCardX, newCardY) is occupied
        for (const card of layoutConfig) {
          const isOverlap =
            card.x < newCardX + 3 &&
            newCardX < card.x + card.w &&
            card.y < newCardY + 6 && // Adjust based on card height
            newCardY < card.y + card.h;

          if (isOverlap) {
            // If overlap, move to next column
            newCardX += card.w;
            if (newCardX >= 12) {
              // Move to next row if no more columns are available
              newCardX = 0;
              newCardY++;
            }
            foundSlot = false;
            break;
          }
        }
      }

      // Add a new card with a unique key
      const newId = (maxKey + 1).toString(); // Ensure the new ID is unique
      delete updatedCard.description;
      delete updatedCard.sampleImg;
      const newCard = { i: newId, x: newCardX, y: newCardY, ...updatedCard };
      const widget = getNewGraphDetails(newCard);
      setLayoutConfig((prevLayout) => [
        ...prevLayout,
        widget ? { ...widget } : { ...newCard, data: [] },
      ]);
      setTimeout(() => {
        movePositionToNewCard(newId);
      }, 100);
    }
    setUnsavedChanges(true);
    setAddEditCard(false);
  };
  ///////
  const handleEditCard = (card) => {
    setSelectedCard(card);
    setAddEditCard(true);
  };

  const handleCardTitle = (id) => {
    setSelectedCardTitle(id);
    setUnsavedChanges(true);
  };

  const handleDeleteCard = (id) => {
    setLayoutConfig((prevLayout) => prevLayout.filter((card) => card.i !== id));
    setUnsavedChanges(true);
  };

  const handleSaveConfig = async () => {
    if (selectedCardTitle) {
      alert("Please save card title");
      return;
    }

    setEditMode(false);
    const getAttribute = await getAttributes();

    // If all widgets are deleted, restore initial layout
    if (layoutConfig.length === 0) {
      const defaultConfig = initialLayoutConfig.map((configWidget) => {
        const { data, ...rest } = configWidget;
        if (infoWidgetList.includes(configWidget.type)) {
          return { ...rest, config: commonWidgetContent };
        }
        return rest;
      });

      const payload = {
        userId: getAttribute[0].userId,
        dashboardConfig: JSON.stringify(defaultConfig),
      };

      dispatch(updateDashboardConfigAsync(payload));
      reloadPage(defaultConfig); // Fetch new data for default widgets
      dispatch(
        updateSnackbar({
          type: "info",
          message: "No widgets on dashboard. Resetting to default layout.",
        }),
      );
      const mappedDefault = defaultConfig.map((widget) =>
        standedCardMappingData(widget),
      );
      setLayoutConfig(mappedDefault);
    } else {
      // Save current layout
      const newLayout = JSON.parse(JSON.stringify(layoutConfig));

      const finalLayout = newLayout.map(({ data, ...rest }) => rest);

      const payload = {
        userId: getAttribute[0].userId,
        dashboardConfig: JSON.stringify(finalLayout),
      };
      reloadPage(finalLayout);
      setLayoutConfig(finalLayout);
      dispatch(updateDashboardConfigAsync(payload));
    }
    setUnsavedChanges(false);
  };

  const handleExport = () => {
    const newLayout = JSON.parse(JSON.stringify(layoutConfig));
    if (newLayout.length > 0) {
      // Convert layout to JSON string
      const jsonData = JSON.stringify(newLayout, null, 2);
      const blob = new Blob([jsonData], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      // Create download link
      const a = document.createElement("a");
      a.href = url;
      a.download = "dashboard_layout.json";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      // Show success message
      dispatch(
        updateSnackbar({
          type: "success",
          message: "Dashboard data exported successfully.",
        }),
      );
    } else {
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Dashboard data export failed.",
        }),
      );
    }
  };

  const handleImport = (file) => {
    // const file = event.target?.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const importedLayout = JSON.parse(e.target.result);
        const teamRole = JSON.parse(decrypt("teamRoles"));
        let dashboardConfig = [];
        if (teamRole === "Recruiter") {
          let restrictedWidgetlist = [
            "candidateDetailsByStatus",
            "GraphbyClient",
            "JobStatusByClient",
            "DeliveryOutcomeByClients",
            "RecruiterContributionByStatus",
            "GraphbyRecruiter",
          ];
          let filterData = importedLayout.filter(
            (x) => !restrictedWidgetlist.includes(x.type),
          );
          dashboardConfig = filterData;
        } else {
          dashboardConfig = importedLayout;
        }
        setLayoutConfig(dashboardConfig); // Set imported layout
        setShowPopup(false);
        dispatch(
          updateSnackbar({
            type: "success",
            message: "Dashboard data imported successfully.",
          }),
        );
        setEditMode(true);
        setUnsavedChanges(true);
      } catch (error) {
        dispatch(
          updateSnackbar({ type: "error", message: "Invalid JSON format." }),
        );
      }
    };
    reader.readAsText(file);
  };

  const onLayoutChange = useCallback(
    (newLayout) => {
      const updatedLayout = newLayout.map((item, index) => ({
        ...layoutConfig[index],
        ...item,
      }));
      // console.log('updatedLayout ++++++++++', updatedLayout);
      setLayoutConfig(updatedLayout);
    },
    [layoutConfig],
  );

  useEffect(() => {
    const updateGridWidth = () => {
      if (containerRef.current) {
        const containerPadding = 40; // 20px padding on each side
        setGridWidth(containerRef.current.offsetWidth - containerPadding);
      }
    };

    updateGridWidth();
    window.addEventListener("resize", updateGridWidth);

    return () => {
      window.removeEventListener("resize", updateGridWidth);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 100);
  }, []);

  useEffect(() => {
    async function init() {
      let userId = await GetUserId();
      let userInfo = await GetUserInfo();
      dispatch(customFieldsAsync(userId));
      if (
        userInfo &&
        userInfo.length > 0 &&
        userInfo[0].teamRoles !== "Recruiter"
      ) {
        setListOfWidgets(
          mergeSortedObjects(listOfWidgets, additionalWidgetTypes, "title"),
        );
        // setListOfWidgets((prev) => [...prev, ...additionalWidgetTypes]);
      } else {
        setListOfWidgets(widgetTypes);
      }
    }
    init();
  }, []);

  function mergeSortedObjects(arr1, arr2, key) {
    let i = 0,
      j = 0;
    const result = [];

    while (i < arr1.length && j < arr2.length) {
      if (arr1[i][key].localeCompare(arr2[j][key]) <= 0) {
        result.push(arr1[i]);
        i++;
      } else {
        result.push(arr2[j]);
        j++;
      }
    }

    return result.concat(arr1.slice(i)).concat(arr2.slice(j));
  }

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const array = getCandidateStatusCustomValues(customFieldsData);
      setCandidateStatusValues(array);
    }
  }, [customFieldsData]);

  useLayoutEffect(() => {
    const newLayout = JSON.parse(JSON.stringify(layoutConfig));
    const finalWidget = newLayout.map((widget) => {
      return standedCardMappingData(widget);
    });
    setLayoutConfig(finalWidget);
  }, [
    infoWidgetsData,
    pieChartData,
    barChartData,
    tableData,
    pieChartSwitchList,
    barChartSwitchList,
    tableSwitchList,
    graphOfStatusData,
    graphByClientData,
    jobStatusByClientData,
    resumeCountByStatus,
    totalUploadedResumes,
    deliveryOutcomeData,
    totalRecruiterData,
    totalRecruiterCount,
    candidateListByStatusData,
  ]);

  useEffect(() => {
    if (widgetsResponse) {
      const infoWidgetData = {};
      layoutConfig.forEach((configWidget) => {
        if (infoWidgetList.includes(configWidget.type)) {
          switch (configWidget.type) {
            case "resume":
              infoWidgetData[configWidget.type] = getResumeInfo(
                widgetsResponse,
                configWidget.type,
              );
              break;
            case "submission":
              infoWidgetData[configWidget.type] = getSubmissionInfo(
                widgetsResponse,
                configWidget.type,
              );
              break;
            case "interview":
              infoWidgetData[configWidget.type] = getInterviewInfo(
                widgetsResponse,
                configWidget.type,
              );
              break;
            case "selected":
              infoWidgetData[configWidget.type] = getSelectedInfo(
                widgetsResponse,
                configWidget.type,
              );
              break;
            default:
              break;
          }
        }
      });
      // console.log('infoWidgetData +++++++++++++++++++++', infoWidgetData);
      setInfoWidgetscData(infoWidgetData);
    }
  }, [widgetsResponse]);

  useEffect(() => {
    if (pieChartResponse) {
      const company = pieChartResponse.companyData.map((list) => ({
        value: list.resumesource_name !== "undefined" ? list.resumecount : null,
        label:
          list.resumesource_name !== "undefined" ? list.resumesource_name : "",
      }));
      const user = pieChartResponse.userData.map((list) => ({
        value: list.resumesource_name !== "undefined" ? list.resumecount : null,
        label:
          list.resumesource_name !== "undefined" ? list.resumesource_name : "",
      }));
      setPieChartData({ company, user });
    }
  }, [pieChartResponse]);

  useEffect(() => {
    if (barChartResponse && candidateStatusValues.length) {
      const companyBarChart = barChartResponse.companyData;
      const companyBarData = companyBarChart.map((list) => list.statusCount);
      const companyBarLabel = companyBarChart.map((list) =>
        getCandidateInternalStatus(list.candidateStatus, candidateStatusValues),
      );
      const company = [companyBarData, companyBarLabel];

      const userBarChart = barChartResponse.userData;
      const userBarData = userBarChart.map((list) => list.statusCount);
      const userBarLabel = userBarChart.map((list) =>
        getCandidateInternalStatus(list.candidateStatus, candidateStatusValues),
      );
      const user = [userBarData, userBarLabel];

      setBarChartData({ company, user });
    }
  }, [barChartResponse, candidateStatusValues]);

  useEffect(() => {
    if (
      requirementAssignedResponse !== null &&
      requirementAssignedResponse !== undefined
    ) {
      if (
        requirementAssignedResponse?.companyData ||
        requirementAssignedResponse?.userData
      ) {
        const company = JSON.parse(
          JSON.stringify(requirementAssignedResponse?.companyData),
        );
        const user = JSON.parse(
          JSON.stringify(requirementAssignedResponse?.userData),
        );
        setTableData({ company, user });
      }
    }
  }, [requirementAssignedResponse]);

  useEffect(() => {
    if (!candidateListByStatusResponse) return;
    let modeledData = JSON.parse(
      JSON.stringify(candidateListByStatusResponse.data),
    );
    modeledData.forEach(
      (list) => (list.updatedDate = GetTimeZone(list.updatedDate)),
    );
    let resultByWidgetId = [];
    resultByWidgetId[candidateListByStatusResponse.widgetId] = {
      data: modeledData,
      widgetId: candidateListByStatusResponse.widgetId,
    };
    setCandidateListByStatusData((prev) => ({ ...prev, ...resultByWidgetId }));
    dispatch(_appSer.getCandidateListByStatusStartReducer(initalState));
  }, [candidateListByStatusResponse]);

  useEffect(() => {
    const widgetKeys = Object.keys(graphOfStatus || {});
    if (widgetKeys.length) {
      const graphOfStatusObj = {};
      widgetKeys.forEach((key) => {
        const barData = graphOfStatus[key].map((list) => list.statusCount);
        const barLabel = graphOfStatus[key].map((list) =>
          getCandidateInternalStatus(
            list.candidateStatus,
            candidateStatusValues,
          ),
        );
        const data = [barData, barLabel];
        graphOfStatusObj[key] = data;
      });
      setGraphOfStatusData(graphOfStatusObj);
    }
  }, [graphOfStatus, candidateStatusValues]);

  useEffect(() => {
    const widgetKeys = Object.keys(graphbyclients || {});
    if (widgetKeys.length) {
      const clientData = {};
      widgetKeys.forEach((key) => {
        const newArray = graphbyclients[key].map((list) => ({
          value: list.statusCount,
          label: getCandidateInternalStatus(
            list.candidateStatus,
            candidateStatusValues,
          ),
        }));
        clientData[key] = newArray;
      });
      setGraphByClientData(clientData);
    }
  }, [graphbyclients, candidateStatusValues]);

  useEffect(() => {
    const widgetKeys = Object.keys(jobStatusByClient || {});
    if (widgetKeys.length) {
      const clientData = {};
      widgetKeys.forEach((key) => {
        const newArray = jobStatusByClient[key].map((item) => ({
          value: item.count,
          label: item.status,
        }));
        clientData[key] = newArray;
      });
      setJobStatusByClientData(clientData);
    }
  }, [jobStatusByClient]);

  useEffect(() => {
    if (!deliveryOutcome) return;
    let formattedData = [],
      statusKeys = [];
    let modeledData = JSON.parse(JSON.stringify(deliveryOutcome.data));
    modeledData.forEach((widget) => {
      // const parsed = JSON.parse(widget.data);
      if (widget.clientname.length > 12) {
        widget.clientname = widget.clientname.slice(0, 12) + "...";
      }
      formattedData.push({
        id: widget.id,
        title: widget.clientname,
        ...widget.data,
      });
      statusKeys.push(...Object.keys(widget.data));
    });

    const unique = [...new Set(statusKeys)];

    const seriesObject = unique.map((status, i) => ({
      dataKey: status,
      label: status,
      color: randomColors[i % randomColors.length],
      stack: "a",
    }));

    let resultByWidgetId = [];
    resultByWidgetId[deliveryOutcome.widgetId] = {
      data: formattedData,
      series: seriesObject,
      widgetId: deliveryOutcome.widgetId,
    };
    setDeliveryOutcomeData((prev) => ({ ...prev, ...resultByWidgetId }));
    dispatch(_appSer.getDeliveryOutcomeByClientsStartReducer(initalState));
  }, [deliveryOutcome]);

  useEffect(() => {
    if (!RecruiterStatusResponse) return;
    let formattedData = [],
      statusKeys = [];
    let modeledData = JSON.parse(JSON.stringify(RecruiterStatusResponse.data));
    modeledData.forEach((widget) => {
      if (widget.recruiterName.length > 12) {
        widget.recruiterName = widget.recruiterName.slice(0, 12) + "...";
      }
      formattedData.push({
        id: widget.recruiterId,
        title: widget.recruiterName,
        ...widget.statuses,
      });
      statusKeys.push(...Object.keys(widget.statuses));
    });
    const unique = [...new Set(statusKeys)];
    const seriesObject = unique.map((status, i) => ({
      dataKey: status,
      label: status,
      color: randomColors[i % randomColors.length],
      stack: "a",
    }));
    let resultByWidgetId = [];
    resultByWidgetId[RecruiterStatusResponse.widgetId] = {
      data: formattedData,
      series: seriesObject,
      widgetId: RecruiterStatusResponse.widgetId,
    };
    setTotalRecruiterData((prev) => ({ ...prev, ...resultByWidgetId }));
    dispatch(_appSer.getTotalRecruiterStartReducer(initalState));
  }, [RecruiterStatusResponse]);

  useEffect(() => {
    if (!totalRecruiterCountResponse) return;
    const result = totalRecruiterCountResponse?.data.map((item, i) => {
      const recruiterName =
        item.recruiterName.length > 12
          ? item.recruiterName.slice(0, 12) + "..."
          : item.recruiterName;
      return {
        ...item,
        recruiterName,
        color: randomColors[i % randomColors.length],
      };
    });
    let resultByWidgetId = [];
    resultByWidgetId[totalRecruiterCountResponse.widgetId] = {
      data: result,
      widgetId: totalRecruiterCountResponse.widgetId,
    };
    setTotalRecruiterCount((prev) => ({ ...prev, ...resultByWidgetId }));
    dispatch(_appSer.getTotalRecruiterStartReducer(initalState));
  }, [totalRecruiterCountResponse]);

  useEffect(() => {
    const widgetKeys = Object.keys(resumeContributedByStatus || {});
    if (resumeContributedByStatus && widgetKeys.length) {
      const clientData = {};
      widgetKeys.forEach((key) => {
        const resumeCountObj = resumeContributedByStatus[key];
        const currentValue = resumeCountObj.totalResumeCount || 0;
        const avgValue = resumeCountObj?.averageResumes?.toFixed(0) || 0;
        const highestValue = resumeCountObj?.highestResumes?.toFixed(0) || 0;
        const avgPercentage =
          highestValue > 0 ? (avgValue / highestValue) * 100 : 0;
        clientData[key] = {
          currentValue,
          avgValue,
          highestValue,
          avgPercentage,
        };
      });
      setResumeCountByStatus(clientData);
    }
  }, [resumeContributedByStatus, candidateStatusValues]);

  useEffect(() => {
    const widgetKeys = Object.keys(totalResumesData || {});
    if (totalResumesData && widgetKeys.length) {
      const clientData = {};
      widgetKeys.forEach((key) => {
        const totalResumesObj = totalResumesData[key];
        const currentValue = totalResumesObj.totalResumeCount || 0;
        const avgValue = totalResumesObj?.averageResumes?.toFixed(0) || 0;
        const highestValue = totalResumesObj?.highestResumes?.toFixed(0) || 0;
        const avgPercentage =
          highestValue > 0 ? (avgValue / highestValue) * 100 : 0;
        clientData[key] = {
          currentValue,
          avgValue,
          highestValue,
          avgPercentage,
        };
      });
      setTotalUploadedResumes(clientData);
    }
  }, [totalResumesData]);

  useLayoutEffect(() => {
    const init = async () => {
      const safeParse = (key) => {
        try {
          return JSON.parse(sessionStorage.getItem(key));
        } catch {
          return null;
        }
      };

      const modifyDashboardConfig =
        safeParse("DashboardConfig") || initialLayoutConfig;
      const userInfo = await GetUserInfo();
      let userCountries = JSON.parse(userInfo[0].selectedcountries);
      const teamRole = userInfo[0].teamRoles;
      let dashboardConfig = [];
      if (teamRole === "Recruiter") {
        let restrictedWidgetlist = [
          "candidateDetailsByStatus",
          "GraphbyClient",
          "JobStatusByClient",
          "DeliveryOutcomeByClients",
          "RecruiterContributionByStatus",
          "GraphbyRecruiter",
        ];
        let filterData = modifyDashboardConfig.filter(
          (x) => !restrictedWidgetlist.includes(x.type),
        );
        dashboardConfig = filterData;
      } else {
        dashboardConfig = modifyDashboardConfig;
      }
      const finalConfig = dashboardConfig.map((configWidget) => {
        if (infoWidgetList.includes(configWidget.type)) {
          return { ...configWidget, config: commonWidgetContent };
        } else {
          return { ...configWidget };
        }
      });
      setLayoutConfig(finalConfig);
      reloadPage(finalConfig);
    };
    init();
  }, []);

  const handleCancelConfig = () => {
    if (!unsavedChanges) {
      setLayoutConfig(previouslayoutConfig);
      setEditMode(false);
    } else {
      navigate("/ats/layout2");
    }
  };

  useEffect(() => {
    async function processConfirmedPopup() {
      if (isConfirmedPopup === "cancel") {
        setUnsavedChanges(false);
        setLayoutConfig(previouslayoutConfig);
        reloadPage(previouslayoutConfig);
        const getAttribute = await getAttributes();
        const payload = {
          userId: getAttribute[0].userId,
          dashboardConfig: JSON.stringify(previouslayoutConfig),
        };
        dispatch(updateDashboardConfigAsync(payload));
        setEditMode(false);
        dispatch(setConfirmed(""));
      }
    }
    processConfirmedPopup();
  }, [isConfirmedPopup]);

  const loadWidgets = (card) => {
    switch (card.type) {
      case "JobStatusByClient":
        return (
          <PieChartWidgetCard
            card={card}
            editMode={editMode}
            cardTitleChangeId={selectedCardTitle}
            handleCardTitle={(id) => handleCardTitle(id)}
            handleSaveCardTitle={(id, title) => handleSaveCardTitle(id, title)}
            handleDeleteCard={(id) => handleDeleteCard(id)}
            handleEditCard={(card) => handleEditCard(card)}
          />
        );
      case "GraphbyClient":
        return (
          <PieChartWidgetCard
            card={card}
            editMode={editMode}
            cardTitleChangeId={selectedCardTitle}
            handleCardTitle={(id) => handleCardTitle(id)}
            handleSaveCardTitle={(id, title) => handleSaveCardTitle(id, title)}
            handleDeleteCard={(id) => handleDeleteCard(id)}
            handleEditCard={(card) => handleEditCard(card)}
          />
        );
      case "pieChart":
        return (
          <PieChartWidgetCard
            card={card}
            editMode={editMode}
            showToggle={showToggle}
            cardTitleChangeId={selectedCardTitle}
            handleCardTitle={(id) => handleCardTitle(id)}
            switchChange={(value) => pieChartSwitchChange(value, card)}
            handleSaveCardTitle={(id, title) => handleSaveCardTitle(id, title)}
            handleDeleteCard={(id) => handleDeleteCard(id)}
            handleEditCard={(card) => handleEditCard(card)}
          />
        );
      case "GraphofStatus":
        return (
          <BarChartWidgetCard
            card={card}
            editMode={editMode}
            cardTitleChangeId={selectedCardTitle}
            handleCardTitle={(id) => handleCardTitle(id)}
            handleSaveCardTitle={(id, title) => handleSaveCardTitle(id, title)}
            handleDeleteCard={(id) => handleDeleteCard(id)}
            handleEditCard={(card) => handleEditCard(card)}
          />
        );
      case "barChart":
        return (
          <BarChartWidgetCard
            card={card}
            editMode={editMode}
            showToggle={showToggle}
            cardTitleChangeId={selectedCardTitle}
            handleCardTitle={(id) => handleCardTitle(id)}
            switchChange={(value) => barChartSwitchChange(value, card)}
            handleSaveCardTitle={(id, title) => handleSaveCardTitle(id, title)}
            handleDeleteCard={(id) => handleDeleteCard(id)}
            handleEditCard={(card) => handleEditCard(card)}
          />
        );
      case "requirementsWidget":
      case "candidateDetailsByStatus":
        return (
          <TableWidgetCard
            card={card}
            editMode={editMode}
            showToggle={
              card.type !== "candidateDetailsByStatus" ? showToggle : false
            }
            cardTitleChangeId={selectedCardTitle}
            handleCardTitle={(id) => handleCardTitle(id)}
            switchChange={(value) => tableSwitchChange(value, card)}
            handleSaveCardTitle={(id, title) => handleSaveCardTitle(id, title)}
            handleDeleteCard={(id) => handleDeleteCard(id)}
            handleEditCard={(card) => handleEditCard(card)}
            dynamicHeight={card.h * 40}
          />
        );
      case "DeliveryOutcomeByClients":
      case "RecruiterContributionByStatus":
        return (
          <LinearProgressWidgetCard
            card={card}
            editMode={editMode}
            showToggle={showToggle}
            cardTitleChangeId={selectedCardTitle}
            handleCardTitle={(id) => handleCardTitle(id)}
            switchChange={(value) => pieChartSwitchChange(value, card)}
            handleSaveCardTitle={(id, title) => handleSaveCardTitle(id, title)}
            handleDeleteCard={(id) => handleDeleteCard(id)}
            handleEditCard={(card) => handleEditCard(card)}
          />
        );
      case "GraphbyRecruiter":
        return (
          <LinearProgressGraphWidgetCard
            card={card}
            editMode={editMode}
            showToggle={showToggle}
            cardTitleChangeId={selectedCardTitle}
            handleCardTitle={(id) => handleCardTitle(id)}
            switchChange={(value) => pieChartSwitchChange(value, card)}
            handleSaveCardTitle={(id, title) => handleSaveCardTitle(id, title)}
            handleDeleteCard={(id) => handleDeleteCard(id)}
            handleEditCard={(card) => handleEditCard(card)}
          />
        );
      default:
        return (
          <InformationWidgetCard
            card={card}
            editMode={editMode}
            cardTitleChangeId={selectedCardTitle}
            handleCardTitle={(id) => handleCardTitle(id)}
            handleSaveCardTitle={(id, title) => handleSaveCardTitle(id, title)}
            handleDeleteCard={(id) => handleDeleteCard(id)}
            handleEditCard={(card) => handleEditCard(card)}
          />
        );
    }
  };

  return (
    <div ref={containerRef} className="dashboard">
      <DateTimeContainer
        setEditMode={(value) => {
          setPreviouslayoutConfig(layoutConfig);
          setEditMode(value);
        }}
        updateDate={(range) => setSelectedDate(range)}
        handleSaveConfig={() => handleSaveConfig()}
        reloadWidgets={() => reloadPage(layoutConfig)}
        handleCancelConfig={() => handleCancelConfig()}
        editMode={editMode}
        handleExport={() => handleExport()}
        handleImport={() => setShowPopup(true)}
        handleAddCard={() => {
          setSelectedCard(null);
          setAddEditCard(true);
        }}
      />
      {addEditCard && (
        <AddEditModal
          open={addEditCard}
          submit={(data) => handleAddCard(data)}
          selectedCard={selectedCard}
          widgetTypes={listOfWidgets}
          closeDialog={() => {
            setSelectedCard(null);
            setAddEditCard(false);
          }}
        />
      )}

      {showPopup && (
        <ImportModal
          onClose={() => setShowPopup(false)}
          onFileSelect={(event) => handleImport(event)}
        />
      )}
      <GridLayout
        className="dashboard__grid layout"
        layout={layoutConfig}
        cols={12}
        rowHeight={50}
        width={gridWidth}
        isResizable={editMode}
        isDraggable={editMode}
        onLayoutChange={onLayoutChange}
        margin={[20, 20]}
        draggableCancel=".dashboard__card-icons, .save-btn, .dashboard__card-edit-icon, .dashboard__card-header-section, .switch-container"
      >
        {layoutConfig.map((card) => {
          return (
            <div
              key={card.i}
              data-grid-id={card.i}
              data-grid={card}
              className={card.className}
            >
              {loadWidgets(card)}
            </div>
          );
        })}
      </GridLayout>
    </div>
  );
};

export default ApplicantsNewDashboard;
